export default __webpack_public_path__ + "static/media/information--end-of-limited-access-road--g1.4d253455.png";